// Legacy code, credits to Juan Carlos Casado.

import IpV4 from "./ipv4.js"
import IpV6 from "./ipv6.js"

//
// IpV4V6
//
var IpV4V6 = (function() {
  var _public = {
    isValid: function(s) {
      return (IpV4.isValid(s) || IpV6.isValid(s));
    },
    isValidCidr: function(s) {
      return (IpV4.isValidCidr(s) || IpV6.isValidCidr(s));
    },
    isValidCidrOrAddr: function(s) {
      return (IpV4.isValidCidrOrAddr(s) || IpV6.isValidCidrOrAddr(s));
    },
    normalizeCidr: function(s) {
      if (IpV4.isValid(s)) {
        return IpV4.normalizeCidr(s);
      } else if (IpV6.isValid(s)) {
        return IpV6.normalizeCidr(s);
      } else {
        return s;
      }
    },
  };

  return _public;
})();

export default IpV4V6
